import { Controller } from "stimulus"

export default class extends Controller {
  disabled(){
    alert("Buyer account required for order requests!");
  }
}